import { CollectionConfig } from "common/contentCollection";

export type PersonalizedCollectionConfig = Pick<
  CollectionConfig,
  "personalization"
>;

export const defaultConfig: CollectionConfig = {
  card: {
    layout: "grid",
    variant: "transparent",
  },
  item: {
    variant: "tile",
  },
  personalization: {
    campaignName: "unknown",
    googleClientId: "unknown",
    allowEnglishFallbacks: false,
    fallbackItems: [
      {
        name: "salesforce-quick-look-1",
        type: "MODULE",
      },
      {
        name: "salesforce-customer-360",
        type: "MODULE",
      },
      {
        name: "lex_implementation_basics",
        type: "MODULE",
      },
    ],
  },
};
